import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Proiecte from "@/pages/Proiecte";
import Contact from "@/pages/Contact";
import Rise27 from "@/pages/Rise27";
import Admin from "@/pages/Admin";
import ConfirmaCod from "@/pages/ConfirmaCod";
import Redirectioneaza from "@/pages/Redirectioneaza";
import Transparenta from "@/pages/Transparenta";
import Cupa from "@/pages/Cupa";
import CupaInscriere from "@/pages/CupaInscriere";
import Termeni from "@/pages/Termeni";
import Bushido from "@/pages/Bushido";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const GrainOverlay = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-[90] opacity-[0.05] mix-blend-overlay"
    style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
    }}
  />
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-canvas text-neutral-100 font-body antialiased">
        <GrainOverlay />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/proiecte" element={<Proiecte />} />
            <Route path="/bushido-vs-bullying" element={<Bushido />} />
            <Route path="/rise27" element={<Rise27 />} />
            <Route path="/cupa-caritabila" element={<Cupa />} />
            <Route path="/cupa-caritabila/inscriere" element={<CupaInscriere />} />
            <Route path="/termeni-si-conditii" element={<Termeni />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/confirma-cod" element={<ConfirmaCod />} />
            <Route path="/redirectioneaza-3-5" element={<Redirectioneaza />} />
            <Route path="/transparenta" element={<Transparenta />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme="dark" position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
